import React from 'react'
import { Box, Chip, Tooltip, Typography } from '@material-ui/core'
import { isEmpty } from 'lodash'

const TagColumn = ({
  icon,
  title,
  tags,
  width = '50%',
  justifyContent = 'flex-start',
  isTag = false,
  ...rest
}) => {
  let tagNames = tags?.map((tag) => tag.name) || []

  return (
    <Box
      width={width}
      display="flex"
      alignItems="center"
      p={1}
      justifyContent={justifyContent}
    >
      <Box px={1} py={2}>
        {icon}
      </Box>
      <Box maxWidth="87%">
        <Typography variant="subtitle2">{title}</Typography>
        <Box {...rest}>
          {isEmpty(tags) ? (
            <Typography color="secondary" {...rest}>
              -
            </Typography>
          ) : (
            <Tooltip title={tagNames[0]} placement="bottom-start">
              <Chip label={tagNames[0]} size="small" />
            </Tooltip>
          )}
          {tagNames.length > 1 && (
            <Tooltip
              title={tagNames.slice(1).join(', ')}
              placement="bottom-start"
            >
              <Chip label={`+${tagNames.length - 1}`} size="small" />
            </Tooltip>
          )}
        </Box>
      </Box>
    </Box>
  )
}

export default TagColumn
